import { Suspense, lazy, memo } from 'react'

import { PageProps } from '~/shared/types/commonTypes'

const Goal = lazy(
  () => import('~/pages/onboarding/introCard/libs/components/Goal'),
)
const Interactivity = lazy(
  () => import('~/pages/onboarding/introCard/libs/components/Interactivity'),
)
const Discovery = lazy(
  () => import('~/pages/onboarding/introCard/libs/components/Discovery'),
)
const Uncover = lazy(
  () => import('~/pages/onboarding/introCard/libs/components/Uncover'),
)
const Knowledge = lazy(
  () => import('~/pages/onboarding/introCard/libs/components/Knowledge'),
)
const KeepGrowing = lazy(
  () => import('~/pages/onboarding/introCard/libs/components/KeepGrowing'),
)
const GoodCompany = lazy(
  () => import('~/pages/onboarding/introCard/libs/components/GoodCompany'),
)
const Graph = lazy(
  () => import('~/pages/onboarding/introCard/libs/components/Graph'),
)
const NeverStopLearning = lazy(
  () =>
    import('~/pages/onboarding/introCard/libs/components/NeverStopLearning'),
)

const IntroCardRoot = ({ nextPagePath, pageId }: PageProps) => (
  <Suspense fallback={null}>
    <Goal nextPagePath={nextPagePath} pageId={pageId} />
    <Interactivity nextPagePath={nextPagePath} pageId={pageId} />
    <Discovery nextPagePath={nextPagePath} pageId={pageId} />
    <Uncover nextPagePath={nextPagePath} pageId={pageId} />
    <Knowledge nextPagePath={nextPagePath} pageId={pageId} />
    <KeepGrowing nextPagePath={nextPagePath} pageId={pageId} />
    <GoodCompany nextPagePath={nextPagePath} pageId={pageId} />
    <Graph nextPagePath={nextPagePath} pageId={pageId} />
    <NeverStopLearning nextPagePath={nextPagePath} pageId={pageId} />
  </Suspense>
)

const IntroCard = Object.assign(memo(IntroCardRoot), {
  Goal,
  Interactivity,
  Discovery,
  Uncover,
  Knowledge,
  KeepGrowing,
  GoodCompany,
  Graph,
  NeverStopLearning,
})

export default IntroCard
